import React, { useState } from 'react'
import { FaInfoCircle, FaTimes } from 'react-icons/fa'

const TCLE_VIDEO_ID = 'tValnvIalmk'
const GENETICS_TCLE = 'Portador Saudável (TCLE)'

interface DonorGeneticsSectionProps {
  genetics: string | null
  hasTecle: boolean
  donorId: string
}

const DonorGeneticsSection: React.FC<DonorGeneticsSectionProps> = ({ genetics, hasTecle, donorId }) => {
  const [ showTecleVideo, setShowTecleVideo ] = useState<boolean>(false)

  return (
    <div className="donor-card__genetics-section">
      <span className="donor-type__label">
        Genética
        <span
          className="donor-type__info-icon"
          role="button"
          tabIndex={0}
          title="Clique para assistir o vídeo explicativo sobre TCLE."
          onClick={e => {
            e.preventDefault()
            setShowTecleVideo(true)
          }}
        >
          <FaInfoCircle />
        </span>
      </span>
      <span className="donor-genetics__value">{genetics || '—'}</span>
      {hasTecle && genetics === GENETICS_TCLE && (
        <span className="donor-tecle-badge donor-tecle-badge--static" id={`tecle-badge-${donorId}`}>
          TCLE
        </span>
      )}

      {showTecleVideo && (
        <div
          className="video-lightbox-overlay"
          onClick={() => setShowTecleVideo(false)}
        >
          <div className="video-lightbox-content" onClick={e => e.stopPropagation()}>
            <button
              type="button"
              className="video-lightbox-close"
              onClick={() => setShowTecleVideo(false)}
              aria-label="Fechar"
            >
              <FaTimes size={20} />
            </button>
            <div className="video-lightbox-ratio">
              <iframe
                src={`https://www.youtube.com/embed/${TCLE_VIDEO_ID}?autoplay=1`}
                title="Vídeo explicativo sobre TCLE"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="video-lightbox-iframe"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default DonorGeneticsSection
